import useApiHook from '../../../../hooks/api/useApiHook';
import { useCallback } from 'react';

export const usePostAllCustomers = () => {
  const { post, data, error, loading } = useApiHook(true);

  const getAllCustomers = useCallback(
    async (query) => {
      await post('/summary-customers/find', query);
    },
    [post],
  );

  return { getAllCustomers, data, error, loading };
};

export const useAllCustomersExport = () => {
  const { post, data, error, loading } = useApiHook(true);

  const getAllCustomersExport = useCallback(
    async (query) => {
      await post('/summary-customers/export', query, { responseType: 'blob' });
    },
    [post],
  );

  return { getAllCustomersExport, data, error, loading };
};

export const useImportCustomers = () => {
  const { post, data, error, loading } = useApiHook(true);

  const uploadCustomers = useCallback(
    async (form) => {
      await post('/customers/do-import', form);
    },
    [post],
  );

  return { uploadCustomers, data, error, loading };
};
